// extracted by mini-css-extract-plugin
module.exports = {"risk-warning-item":"risk-warning-item--FXH9qemi","orange-bg":"orange-bg--2xaPOgmW","red-bg":"red-bg--1FIHgwqX","blue-bg":"blue-bg--1aiW_2iq"};